import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from '../../services/authentication/auth.service';
import { TextSizeService } from '../../services/text-size.service';
import { ThemeService } from '../../services/theme.service';
import { SyncService } from '../../services/offline/sync.service';
import { AppToastHostComponent } from '../components/toast/app-toast-host.component';
import { NetworkToastBridgeService } from '../../services/network-toast-bridge.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-root',
  host: {
    class:
      'block app-viewport-min-height overflow-hidden bg-quarternary text-primary',
  },
  imports: [RouterOutlet, AppToastHostComponent],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  readonly bannerText: string | null;

  private readonly authService = inject(AuthService);
  private readonly themeService = inject(ThemeService);
  private readonly textSizeService = inject(TextSizeService);
  private readonly syncService = inject(SyncService);
  private readonly networkToastBridgeService = inject(
    NetworkToastBridgeService
  );

  constructor() {
    if (environment.production) {
      this.bannerText = null;
    } else if (environment.staging) {
      this.bannerText = 'STAGING';
    } else {
      this.bannerText = 'DEVELOPMENT';
    }
  }

  ngOnInit(): void {
    this.themeService.initializeTheme();
    this.textSizeService.initializeTextSize();
    this.authService.isAuthenticated().subscribe(isAuth => {
      if (!isAuth) {
        const jwt = this.getJwtFromCookie();
        if (jwt) {
          this.authService.processToken(jwt);
        }
      }
    });

    this.syncService.syncData();
  }

  private getJwtFromCookie(): string | null {
    const jwtMatch = RegExp(/jwt=([^;]+)/).exec(document.cookie);
    return jwtMatch ? jwtMatch[1] : null;
  }
}
